import { useTranslation } from "react-i18next";
import { Button } from "antd";
import { useState } from "react";
import { ReactComponent as Refresh } from "assets/icons/refresh.svg";
import SubmitButton from "./button";

import ResetRiskModal from "./modal";

const RiskBoard = ({
  disabled,
  loading,
  score,
  riskTaking,
  onFinishRisk,
  onStartSurvey,
}) => {
  const { t } = useTranslation();
  const [openRiskModal, setOpenRiskModal] = useState(false);
  const [starting, setStarting] = useState(false);
  const newScore = (180 / 100) * score;

  const handleRiskStatusChecker = () => {
    switch (true) {
      case score <= 50:
        return ["text-primary-0", "محافظه‌کار", "low"];

      case score > 50 && score <= 70:
        return ["text-success-0", "متعادل", "mid"];

      case score > 70:
        return ["text-warning-0", "ریسک‌پذیر", "high"];
      default:
        return ["", ""];
    }
  };

  const handleCloseRiskModal = () => !loading && setOpenRiskModal(false);
  const handleOpenRiskModal = () => setOpenRiskModal(true);

  return (
    <>
      <div className="p-8">
        <div className="flex justify-center relative">
          <div className="table m-auto relative px-4 pb-3">
            <img
              alt=""
              className="h-[162px] w-auto"
              src="https://cdn.firouzeh.com/public/risk.png"
            />
            <div className="risk-aghrabe">
              <img
                src="https://cdn.firouzeh.com/public/aghrabe.png"
                className={`w-[103px] transform rotate-${newScore} ${
                  handleRiskStatusChecker()[2]
                } h-auto`}
                alt=""
              />
            </div>
          </div>
        </div>
        <h1
          className={`body-16px-demibold mt-3 ${
            handleRiskStatusChecker()[0]
          } text-center`}
        >
          {riskTaking}
        </h1>
        <div className="border border-gray--8 p-1 rounded-lg mt-12 ">
          <div className="flex flex-col gap-3 py-4 px-3 rounded-lg bg-white shadow-lg">
            <h2 className="body-16px-demibold m-0">
              {`${t("pma-onboarding.you-individual")} `}
              <span className={handleRiskStatusChecker()[0]}>
                {`${riskTaking}`}
              </span>{" "}
              {`${t("pma-onboarding.are")} `}
            </h2>
            <p className="body-14px-regular text-gray-4">
              {t("pma-onboarding.risk-description")}
            </p>
            <div className="flex justify-end">
              <Button
                className="flex gap-1 items-center p-0 w-auto border-none !shadow-none min-h-0 h-auto text-blue-0 caption-12px-demibold"
                onClick={handleOpenRiskModal}
              >
                <Refresh className="w-4 h-4" />
                {t("pma-onboarding.trying-risk-assessment")}
              </Button>
            </div>
          </div>
        </div>
      </div>
      <SubmitButton
        disabled={disabled}
        loading={loading}
        onClick={onFinishRisk}
      />
      <ResetRiskModal
        open={openRiskModal}
        loading={starting}
        setStarting={setStarting}
        onClose={handleCloseRiskModal}
        onResetRiskAssessment={onStartSurvey}
      />
    </>
  );
};

export default RiskBoard;
